/* tslint:disable */
/* eslint-disable */
export enum LoanInformationBaseRequestPeriodTypeEnum {
  None = 'None',
  Weekly = 'Weekly',
  Fortnightly = 'Fortnightly',
  Monthly = 'Monthly'
}
